<app-popover placement="bottom-right" #popover>
  <button
    popover-trigger
    id="menu-burger"
    class="settings-trigger"
    (click)="onSettingsClick(popover)"
    aria-label="Settings"
  >
    <app-icon path="assets/icons/burger_menu.svg" [size]="24" />
  </button>

  <app-menu>
    @if (userLogin(); as user) {
      <div class="user-info">
        <span class="user-name">{{ user.crmName }}</span>
        <span class="user-email">{{ user.email }}</span>
      </div>
    }
    <div class="menu-separator"></div>
    <button id="menu-item-language" class="menu-item" type="button" (click)="openLanguageSelector(popover)">
      <app-icon path="assets/img/globe.svg" [size]="20" />
      {{ localeTriggerLabel }}
    </button>
    <div class="menu-separator"></div>
    @if (userLogin()?.accountType === 'account') {
      <a
        id="menu-item-alert-config"
        class="menu-item"
        (click)="onConfigAlertClick(popover)"
        routerLink="/alerts/config"
      >
        {{ 'ALERT_CONFIGURATION' | translate }}
      </a>
    }
    <a id="menu-item-legal-documents" class="menu-item" (click)="showSignedLegalDocModal(popover)">
      {{ 'SIGNED_LEGAL_DOCUMENTS_MODAL_TITLE' | translate }}
    </a>
    <a
      id="menu-item-legal-notice"
      class="menu-item external-link"
      [href]="legalNoticeUrl()"
      (click)="onLegalNoticeClick(popover)"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'LEGAL_NOTICE_MENU_LINK' | translate }}
    </a>
    <a
      id="menu-item-faq"
      class="menu-item external-link"
      [href]="faqUrl()"
      (click)="onFaqClick(popover)"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'FAQ_MENU_LINK' | translate }}
    </a>
    <div class="menu-separator"></div>
    <a id="menu-item-logout" class="menu-item logout-item" (click)="logout(popover)">
      {{ 'LOGOUT' | translate }}
    </a>
  </app-menu>
</app-popover>

<app-approved-legal-documents-modal
  [open]="legalDocumentApprovalModalOpen()"
  [legalDocumentApproval]="legalDocumentApproval()"
  (closed)="legalDocumentApprovalModalOpen.set(false)"
  (documentDownloaded)="logLegalDocumentAccessInAnalytics($event)"
/>

<app-language-selector [open]="languageSelectorOpen()" (closed)="languageSelectorOpen.set(false)" />
